import pagePermissions from '@/enums/pagePermissions';
import { PermissionMiddleware } from './Middleware/PermissionMiddleware';

const planBatchRoutes = [
  {
    path: '/batch-actions',
    name: 'Batch-actions',
    component: () => import('../Pages/PlanBatchActions.vue'),
    meta: {
      name: 'Массовые действия',
    },
    beforeEnter: PermissionMiddleware,
  },
];

planBatchRoutes.forEach((route) => {
  if (pagePermissions[route.name]) route.meta.permission = pagePermissions[route.name];
});

export { planBatchRoutes };
